/* eslint-disable no-param-reassign */
'use strict';

const { queryFirst, queryAll, addClass, hasClass, removeClass } = require('../domUtil');

const { initOnce } = require('../util');
const hiddenClass = 'd-none';
const mql = window.matchMedia('(max-width: 767px)');
let initialMonogramClick = false;

const styleMap = {
    singleLetterStyle: 'Single Letter',
    doubleLetterStyle: 'Double Letter',
    tripleLetterStyle: 'Triple Letter',
    traditionalLetterStyle: 'Traditional'
};

const colorMap = [
    {
        name: 'Indigo',
        rgb: 'rgb(0, 0, 102)'
    },
    {
        name: 'Resort White',
        rgb: 'rgb(246, 246, 246)'
    },
    {
        name: 'Pasha Pink',
        rgb: 'rgb(245, 85, 123)'
    },
    {
        name: 'Gold',
        rgb: 'rgb(221, 161, 69)'
    }
];

const selectedMonogramValues = {
    monogramInitials: '',
    monogramStyle: '',
    monogramColor: 'Indigo',
    placementSelect: ''
};

let enableContinue = false;

let allInputText = '';

let monogramData = {};

const monogramContinueButton = queryFirst('.monogram-continue-btn');
const monogramModalEl = queryFirst('.monogram-modal');
const initialsButtons = queryFirst('.monogram-style .selected');
const monongramUlEl = queryFirst('.monogram-color');
const selectedClass = 'selected';
const activeViewClass = 'active-view';
const monogramConfirmationView = queryFirst('.monogram-confirmation-view');
const detailViewEl = queryFirst('.monogram-detail-view');

// check selectedMonogramValues and enable continue button if values are set
const updateMonogramValues = (type, value) => {
    selectedMonogramValues[type] = value;

    const { monogramInitials, monogramStyle, monogramColor, placementSelect } = selectedMonogramValues;

    if (monogramInitials.length === 0 || !monogramStyle || !monogramColor || !placementSelect) {
        enableContinue = false;
        monogramContinueButton.setAttribute('disabled', true);
        return;
    }

    enableContinue = true;
    monogramContinueButton.removeAttribute('disabled');
    removeClass(queryFirst('.monogram-incomplete-label'), 'show-error');
};

// This method adds assistive text for selected options at various stages of monogramming selection
const changeSelectedAssistiveText = (assistiveElementSelector, selectedElement) => {
    queryAll(assistiveElementSelector).forEach(eachElement => {
        eachElement.textContent = '';
    });
    const selectedAssistiveElement = queryFirst('.selected-assistive-text', selectedElement);
    selectedAssistiveElement.textContent = selectedAssistiveElement.dataset.selectedText;
};

// toggle style and sample text length
const toggleStyle = style => {
    const monogramDetails = queryFirst('.monogram-customize-details');
    const initialsSampleAll = queryAll('.product-initials-sample');
    const traditionalSampleAll = queryAll('.product-traditional-sample');
    const inputValue = allInputText;
    const monogramStyle = monogramDetails.querySelector('.monogramStyle');

    const setInitials = value => {
        initialsSampleAll.forEach(el => {
            el.textContent = value;
        });
    };

    const selectStyle = (styleSelect, textValue) => {
        const selectedStyleElement = document.getElementById(styleSelect);
        selectedStyleElement.className = 'selectable selected';
        changeSelectedAssistiveText('.monogram-style .selectable .selected-assistive-text', selectedStyleElement);
        monogramStyle.value = styleMap[styleSelect] || '';
        updateMonogramValues('monogramStyle', styleMap[styleSelect]);
        updateMonogramValues('monogramInitials', (textValue || inputValue).toUpperCase());

        if (styleSelect === 'traditionalLetterStyle') {
            traditionalSampleAll.forEach(el => {
                el.querySelector('.first').textContent = textValue.charAt(0);
                el.querySelector('.middle').textContent = textValue.charAt(2);
                el.querySelector('.last').textContent = textValue.charAt(1);
            });
        } else {
            setInitials(textValue || inputValue);
        }
    };

    removeClass(queryAll('.monogram-style .selectable'), 'selected');
    addClass(initialsSampleAll, 'active');
    removeClass(traditionalSampleAll, 'active');
    removeClass(queryFirst('.initials'), 'show-labels');

    const letter1 = inputValue.charAt(0);
    const letter2 = inputValue.charAt(1);
    const letter3 = inputValue.charAt(2);

    switch (style) {
        case 0:
            setInitials('');
            removeClass(initialsButtons, 'selected');
            updateMonogramValues('monogramInitials', '');
            updateMonogramValues('monogramStyle', '');
            addClass(queryFirst('.monogram-incomplete-label'), 'show-error');
            break;
        case 1:
        case 'singleLetterStyle':
            selectStyle('singleLetterStyle', letter1);
            break;

        case 2:
            selectStyle('doubleLetterStyle', inputValue.substr(0, 2));
            break;

        case 'doubleLetterStyle':
            if (inputValue.length === 1) {
                selectStyle('singleLetterStyle');
            } else if (inputValue.length === 3) {
                selectStyle(style, letter1 + letter3);
            } else {
                selectStyle(style, inputValue.substr(0, 2));
            }
            break;

        case 3:
        case 'tripleLetterStyle':
            if (inputValue.length === 2) {
                selectStyle('doubleLetterStyle');
            } else if (inputValue.length === 1) {
                selectStyle('singleLetterStyle');
            } else {
                selectStyle('tripleLetterStyle');
            }
            break;

        case 'traditionalLetterStyle':
            if (inputValue.length === 2) {
                selectStyle('doubleLetterStyle');
            } else if (inputValue.length === 1) {
                selectStyle('singleLetterStyle');
            } else {
                addClass(queryFirst('.initials'), 'show-labels');
                removeClass(initialsSampleAll, 'active');
                addClass(traditionalSampleAll, 'active');
                selectStyle('traditionalLetterStyle', letter1 + letter2 + letter3);
            }
            break;

        default:
            setInitials('');
            break;
    }
};

// resets monnogram values / settings
const resetMonogram = () => {
    // reset initials
    allInputText = '';
    updateMonogramValues('monogramInitials', '');
    queryAll('.monogram-initials').forEach(el => {
        el.value = '';
    });

    // reset color
    updateMonogramValues('monogramColor', 'Indigo');
    removeClass(queryAll('.monogram-color li'), selectedClass);
    addClass(queryFirst('.monogram-color li'), selectedClass);
    queryAll('.monogram-img-wrapper').forEach(el => {
        el.setAttribute('style', `color:${colorMap[0].rgb}`);
    });

    // reset style
    toggleStyle(0);

    // reset placement
    updateMonogramValues('placementSelect', monogramData.monogramLocations[0].displayValue);
    removeClass(queryAll('.monogram-placement li'), selectedClass);
    addClass(queryFirst('.monogram-placement li'), selectedClass);

    // set monongram modal to first view
    removeClass(monogramConfirmationView, activeViewClass);
    removeClass(detailViewEl, hiddenClass);
    addClass(monogramConfirmationView, hiddenClass);
};

const initListeners = () => {
    // Update Selected Sample Text upon entering initials
    queryAll('.monogram-initials').forEach(el => {
        initOnce(el, 'keyup', e => {
            const windowTest = w => {
                if (w.matches) {
                    initOnce(el, 'keydown', e => {
                        const isTabEnterPressed = e.key === 'Tab' || e.keyCode === 9 || e.key === 'Backspace' || e.keyCode === 9 || e.key === 'Delete' || e.keyCode === 46;
                        const max = 1;
                        if (el.value.length >= max && !isTabEnterPressed) {
                            e.preventDefault();
                            return;
                        }
                    });
                }
            };
            windowTest(mql);

            const { target } = e;
            const { keyCode } = e;
            const valid = (keyCode > 46 && keyCode < 91) || (keyCode > 185 && keyCode < 93) || (keyCode > 218 && keyCode < 223) || keyCode === 8;
            const replaceReg = /[^a-z]/gi;

            allInputText = '';
            target.value = target.value.replace(replaceReg, '');
            queryAll('.monogram-initials').forEach(elem => {
                allInputText += elem.value;
            });

            if (valid) {
                toggleStyle(allInputText.length);
            }
        });
    });

    // Update Selected Sample Text Style on style type click
    queryAll('.monogram-style button').forEach(el => {
        initOnce(el, 'click', e => {
            const style = e.target.closest('li').id;
            toggleStyle(style);
        });
    });

    // Update Selected Sample Text Color on color type click
    initOnce(queryFirst('.monogram-close'), 'click', () => {
        resetMonogram();
    });

    // Update Selected Sample Text Color on color type click
    initOnce(monongramUlEl, 'click', e => {
        const { target } = e;
        const parentLI = target.closest('li');
        const btnEl = target.closest('.color-swatch');

        if (!btnEl || hasClass(parentLI, selectedClass)) return;

        queryAll('.monogram-img-wrapper').forEach(element => {
            element.style.color = btnEl.dataset.colorRgb;
        });
        removeClass(queryAll('.monogram-color li'), selectedClass);
        addClass(parentLI, selectedClass);
        changeSelectedAssistiveText('.monogram-color .selectable .selected-assistive-text', target.closest('.selectable'));

        // update monogram obj
        updateMonogramValues('monogramColor', btnEl.dataset.colorName);
    });

    // Update Selected Placement selction on img click
    initOnce(queryFirst('.monogram-placement'), 'click', e => {
        const { target } = e;
        const parentLI = target.closest('li');
        const btnEl = target.closest('.placement-swatch');

        if (!btnEl || hasClass(parentLI, selectedClass)) return;

        removeClass(queryAll('.monogram-placement li'), selectedClass);
        addClass(parentLI, selectedClass);
        changeSelectedAssistiveText('.monogram-placement .selectable .selected-assistive-text', target.closest('.selectable'));

        // update monogram obj
        updateMonogramValues('placementSelect', btnEl.dataset.placement);

        queryFirst('.monogram-confirmation-placement span').textContent = selectedMonogramValues.placementSelect;
    });

    // Enable and show monogram confirmation menu if values selected
    initOnce(monogramContinueButton, 'click', () => {
        addClass(monogramConfirmationView, activeViewClass);
        addClass(detailViewEl, hiddenClass);
        removeClass(monogramConfirmationView, hiddenClass);
    });

    initOnce(queryFirst('.monogram-continue'), 'click', () => {
        if (!enableContinue) {
            addClass(queryFirst('.monogram-incomplete-label'), 'show-error');
        }
    });

    // Go back to monogram selection from confrimation menu
    initOnce(queryFirst('.monogram-go-back'), 'click', () => {
        removeClass(monogramConfirmationView, activeViewClass);
        addClass(monogramConfirmationView, hiddenClass);
        removeClass(detailViewEl, hiddenClass);
    });

    initOnce(queryFirst('.monogram-add-to-tote-btn'), 'click', event => {
        event.preventDefault();
        const data = queryFirst('.monogram-add-to-tote-btn').dataset;
        const url = data.monogramUrl;

        var form = {
            pid: monogramData.monogramProductID,
            monogramValues: JSON.stringify(selectedMonogramValues)
        };
        const spinner = $.spinner();
        spinner.start();
        $('body').trigger('product:beforeAddToCart');
        $.ajax({
            url: url,
            type: 'post',
            data: form,
            success: function (responseData) {
                const { error } = responseData;
                $('#monogram-modal').modal('hide');
                if (error) {
                    // show add to cart toast
                    $('.add-to-cart-messages').remove();
                    if ($('.add-to-cart-messages').length === 0) {
                        $('body').append('<div class="add-to-cart-messages"></div>');
                    }

                    $('.add-to-cart-messages').append('<div class="alert alert-danger add-to-basket-alert text-center" role="alert">' + responseData.message + '</div>');

                    setTimeout(function () {
                        $('.add-to-basket-alert').remove();
                    }, 5000);
                } else {
                    $('.minicart').trigger('count:update', responseData);
                    $('body').trigger('product:afterAddToCart', responseData);
                }
                resetMonogram();
                spinner.stop();
            },
            error: function () {
                spinner.stop();
            }
        });
    });
};

// update dynamic monogram text labels
const appendDynamicText = () => {
    queryAll('.monogram-pattern-img').forEach(el => {
        el.innerHTML = `<img src="${monogramData.monogramImageURL}" srcset="${monogramData.monogramImageSrcSetURL}" alt="${monogramData.monogramSelectedColor}" />`;
    });

    queryAll('.product-name', monogramModalEl).textContent = monogramData.monogramProductName;

    queryAll('.monogram-product-price').forEach(el => {
        el.textContent = monogramData.productPrice;
    });

    queryAll('.monogram-price').forEach(el => {
        el.textContent = monogramData.monogramProductPrice;
    });

    queryFirst('.monogram-pattern span').textContent = monogramData.monogramSelectedColor;

    queryFirst('.monogram-size span').textContent = monogramData.monogramSelectedSize;

    queryFirst('.monogram-price-label span').textContent = monogramData.monogramProductPrice;

    queryFirst('.monogram-total span').textContent = monogramData.totalPrice;
};

const appendColorSwatches = () => {
    if (!colorMap || !colorMap.length) return;
    let monogramColorHtml = '';
    const { stepTitle } = queryFirst('.monogram-customize-details .product-colors .step-title').dataset;
    const { selectedText } = queryFirst('.monogram-customize-details .selected-assistive-text').dataset;

    colorMap.forEach((swatch, i) => {
        if (!swatch) {
            return;
        }
        monogramColorHtml += `<li class="selectable ${i === 0 ? 'selected' : ''}">
                <button class="monogram-swatchanchor color-swatch" data-color-rgb="${swatch.rgb}"
                    aria-label="${stepTitle} ${swatch.name}" aria-describedBy="select-color-${swatch.name.replace(' ', '')}-desc" data-color-name="${swatch.name}">
                    <span class="swatch" aria-label="${swatch.name}">
                        <span class="inner-swatch" style="background-color: ${swatch.rgb};"></span>
                    </span>
                </button>
                <span class="swatchlabel">${swatch.name}</span>
                <span id="select-color-${swatch.name.replace(' ', '')}-desc" class="sr-only selected-assistive-text" data-selected-text="${selectedText}">
                    ${i === 0 ? selectedText : ''}
                </span>
            </li>`;
    });
    monongramUlEl.innerHTML = monogramColorHtml;
};

const appendPositionSwatches = () => {
    const btnPositionData = monogramData.monogramLocations;
    if (!btnPositionData || !btnPositionData.length) return;
    let monogramPositionHtml = '';
    const { stepTitle } = queryFirst('.monogram-customize-details .placement .step-title').dataset;
    const { selectedText } = queryFirst('.monogram-customize-details .selected-assistive-text').dataset;

    btnPositionData.forEach((el, i) => {
        if (!el) {
            return;
        }
        const { displayValue, imgURL, value } = el;
        if (i === 0) {
            updateMonogramValues('placementSelect', displayValue);
            queryFirst('.monogram-confirmation-placement span').textContent = displayValue;
        }
        monogramPositionHtml += `<li class="selectable ${i === 0 ? 'selected' : ''}">
                <button class="monogram-swatchanchor placement-swatch" data-placement="${displayValue}"
                    aria-label="${stepTitle} ${displayValue}" aria-describedBy="select-placement-${displayValue.replace(' ', '')}-desc">
                    <span class="swatch" aria-label="${displayValue}">
                        <img src="${imgURL}" alt="${value}" class="w-100" />
                    </span>
                </button>
                <span class="swatchlabel">${displayValue}</span>
                <span id="select-placement-${displayValue.replace(' ', '')}-desc" class="sr-only selected-assistive-text" data-selected-text="${selectedText}">
                    ${i === 0 ? selectedText : ''}
                </span>
            </li>`;
    });
    queryFirst('.monogram-placement').innerHTML = monogramPositionHtml;
    updateMonogramValues('placementSelect', btnPositionData[0].displayValue);
};

module.exports = {
    checkMonogram: () => {
        const monogramButton = queryFirst('.monogram-btn');
        if (monogramContinueButton) {
            $('body').on('product:afterAttributeSelect product:afterSizeChange', (e, response) => {
                removeClass(monogramConfirmationView, activeViewClass);
                removeClass(detailViewEl, hiddenClass);
                if ('monogramObject' in response.data.product) {
                    monogramData = response.data.product.monogramObject;
                    appendDynamicText();
                    if (!initialMonogramClick) {
                        appendPositionSwatches();
                        appendColorSwatches();
                    }
                    initListeners();
                    if (monogramButton) {
                        removeClass(monogramButton, hiddenClass);
                    }
                    initialMonogramClick = true;
                } else if (monogramButton) {
                    addClass(monogramButton, hiddenClass);
                }
            });
        }
    }
};
